// ABOUTME: Main dashboard layout wrapper with onboarding redirect logic.
// ABOUTME: Renders navbar-sidebar layout with nested routes via Outlet.

import { Navigate, Outlet } from "react-router"
import NavbarSidebarLayout from "@/components/layout/navbar-sidebar"
import { useMeContext } from "@/model/user/provider"
import { createLogger } from "@/model/logger"
import { needsOnboarding } from "@/model/user/onboarding"
import { ONBOARDING_PAGE } from "@shared/constants/navigation"
import { LazyPage } from "./LazyPage"

const logger = createLogger("Dashboard")

export function Dashboard() {
  const { me, currentRole } = useMeContext()

  // Who owes the form lives in one place (model/user/onboarding): a new user is
  // sent in from here, and someone who already filled it in is sent back out of
  // /onboarding by AppRoutes. Coaches are skipped — becoming one required
  // finishing it, and the check would otherwise trip on cache contamination
  // while viewing an athlete's profile. An unloaded flag decides nothing.
  if (needsOnboarding(me, currentRole.isCoach)) {
    logger.info("Redirecting to onboarding", { userId: me.id, isOnboardingFilled: me.isOnboardingFilled })
    return <Navigate to={ONBOARDING_PAGE} />
  }

  // Log if value is undefined - this shouldn't happen normally
  if (me.isOnboardingFilled === undefined) {
    logger.warn("onboardingFilled is undefined - possible cache issue", { userId: me.id })
  }

  return (
    <NavbarSidebarLayout>
      <LazyPage>
        <Outlet />
      </LazyPage>
    </NavbarSidebarLayout>
  )
}
